import React, { useEffect, useState } from 'react';
import OpportunitiesFilter from 'pages/Opportunities/components/OpportunitiesFilter/OpportunitiesFilter';
import { CustomDialog, FilterButton, MobileFilterCont, NewCont, PreferenceText } from './New.styles';
import OpportunitiesContent from '../../OpportunitiesContent/OpportunitiesContent';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_TEXT } = COLORS;
import { Box, Button, Hidden } from '@material-ui/core';
import { useTabAggregates } from '../useTabAggregates';
import { Skeleton } from '@material-ui/lab';
import { ROUTES } from 'shared/constants/ROUTES';
import { useHistory } from 'react-router-dom';
import { opportunitiesDefaultStates } from 'pages/Opportunities/context/OpportunitiesDefaultStates';

interface Props {
  show: boolean;
  jobs?: boolean;
}

const New: React.FC<Props> = ({ show, jobs }) => {
  const subdomain = window.location.hostname.split('.')[0];
  const isJob = subdomain === 'jobs';

  const { publicAggregates, publicLoading, total_filtered_project_count } = useTabAggregates();
  const hideFilters = useContextSelector(OpportunitiesContext, (state) => state.hideFilters);
  const setHideFilters = useContextSelector(OpportunitiesContext, (state) => state.setHideFilters);
  const projectIds = useContextSelector(OpportunitiesContext, (state) => state.filters.project_ids);
  const setOnlyFilters = useContextSelector(OpportunitiesContext, (state) => state.setOnlyFilters);
  const [showMobileFilter, setshowMobileFilter] = useState(false);
  const history = useHistory();
  const opportunityCount =
    (isJob ? publicAggregates?.data?.total_filtered_project_count : total_filtered_project_count) || 0;

  const availableFilter = 0;
  const showFilter = () => {
    setshowMobileFilter(true);
  };

  const clearProjectRoles = () => {
    setOnlyFilters({ ...opportunitiesDefaultStates.filters });
    setTimeout(() => {
      history.push(`${ROUTES.TALENT.OPPORTUNITIES}`);
    }, 100);
  };

  useEffect(() => {
    if (projectIds?.length && !hideFilters) {
      setHideFilters();
    }
  }, [projectIds, hideFilters]);

  return (
    <NewCont style={{ maxHeight: show ? '100%' : 0, padding: jobs ? '10px 20px 20px' : 0 }} jobs={jobs}>
      <Hidden smDown>{!hideFilters ? <OpportunitiesFilter /> : <React.Fragment />}</Hidden>
      <Hidden mdUp>
        <FilterButton variant="outlined" onClick={showFilter}>
          <CustomTypography>
            <span style={{ color: PRIMARY_TEXT, fontWeight: 500 }}>{availableFilter}</span> Filter applied
          </CustomTypography>
        </FilterButton>
      </Hidden>
      <Box display="flex" justifyContent="space-between" style={{ paddingRight: '5px' }}>
        {publicLoading ? (
          <PreferenceText>
            <Skeleton variant="rect" width={300} height={25} />
          </PreferenceText>
        ) : !projectIds?.length ? (
          <PreferenceText>
            You have found
            <span style={{ color: PRIMARY_TEXT }}>
              {' '}
              {opportunityCount} {opportunityCount > 1 ? ' opportunities ' : ' opportunity '}
            </span>
            based on your preferences
          </PreferenceText>
        ) : (
          <React.Fragment />
        )}
        {jobs ? (
          <Hidden smDown>
            <React.Fragment />
          </Hidden>
        ) : projectIds?.length ? (
          <Button style={{ background: 'transparent' }} variant="outlined" color="primary" onClick={clearProjectRoles}>
            Show All Project
          </Button>
        ) : (
          <React.Fragment />
        )}
      </Box>
      <OpportunitiesContent jobs={jobs} />
      {showMobileFilter ? (
        <CustomDialog
          open={showMobileFilter}
          onClose={() => setshowMobileFilter(false)}
          maxWidth="sm"
          fullWidth
          aria-labelledby="simple-dialog-title"
        >
          <MobileFilterCont>
            <OpportunitiesFilter />
          </MobileFilterCont>
        </CustomDialog>
      ) : (
        <React.Fragment />
      )}
    </NewCont>
  );
};

export default React.memo(New);
